import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const GetContact = (id) => {
  const url = `${apiConstants.Get}?Id=${id}`;

  return httpClient.get(url).then(result => result.data.result);
};

const GetAllContacts = (id) => {
  const url = apiConstants.GetAll;
  const keywordString = keyword !== null ? `Keyword=${keyword}&` : '';
  return httpClient.get(`${url}?${keywordString}IsActive=${isActive}&SkipCount=${skipCount}&MaxResultCount=${maxResultCount}`).then(result => result.data.result);
};


export { GetContact, GetAllContacts };
